<template>
  <layout>
    <template v-slot:title>Create Section</template>
    <section-form
      @save="savedOrCanceled"
      @cancel="savedOrCanceled"
    ></section-form>
  </layout>
</template>
<script>
import SectionForm from "@/components/sections/SectionForm.vue";

export default {
  components: { SectionForm },
  methods: {
    savedOrCanceled: function() {
      this.$router.push("/sections");
    },
  },
};
</script>
